import { createTheme } from '@mui/material/styles';
import { CONFIG_APP_PRIMARY_DARK_COLOR, CONFIG_APP_PRIMARY_LIGHT_COLOR } from '../src/configApp';

// Retrieve the mode from localStorage, default to 'light'
const currentMode = localStorage.getItem("mode") || "light";

// Create the theme based on the current mode
export const theme = createTheme({
  palette: {
    mode: currentMode, // Default to 'light' if no mode is found in localStorage
    primary: {
      main: currentMode === "dark" ? CONFIG_APP_PRIMARY_DARK_COLOR : CONFIG_APP_PRIMARY_LIGHT_COLOR,
    },
    secondary: {
      main: "#ffcc80", // You can replace this with any custom color
    },
  },
  typography: {
    fontFamily: "Rubik", // Custom font
    color: "#f5f5f5", // Soft white text color for a modern look
  },
  shape: {
    borderRadius: 8, // Slightly round edges for all components
    borderBottomRightRadius: 0, // Custom border radius for certain elements
  },
  components: {
    // Apply a global background gradient to all MuiCard components
    MuiCard: {
      styleOverrides: {
        root: {
          background: currentMode === 'dark'
            ? 'linear-gradient(rgb(34, 34, 34), rgb(0, 0, 0))'
            : 'white',
          borderRadius: 8, // Rounded corners for a modern look
          boxShadow: currentMode === 'dark' ? '0px 4px 16px rgba(0, 0, 0, 0.5)' : 'none', // Subtle shadow
          transition: 'background 0.3s ease, box-shadow 0.3s ease', // Smooth transition when changing themes
        },
      },
    },
    // Apply a modern look to MuiPaper
    MuiPaper: {
      styleOverrides: {
        root: {
          background: currentMode === 'dark'
            ? 'linear-gradient(135deg, rgba(34, 34, 34, 0.9), rgba(18, 18, 18, 0.9))'
            : '#ffffff', // White background in light mode
          boxShadow: currentMode === 'dark' ? '0px 4px 16px rgba(0, 0, 0, 0.5)' : '0px 2px 6px rgba(0, 0, 0, 0.1)', // Subtle shadow for both modes
          transition: 'background 0.3s ease, box-shadow 0.3s ease', // Smooth transition
        },
      },
    },
    // Apply the same sleek look to MuiDialog
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: currentMode === 'dark' ? '#12121200' : '#ffffff', // Dark transparent bg for dark mode, white for light mode
          borderRadius: 12, // Slightly rounder for Dialog for a soft look
          boxShadow: currentMode === 'dark' ? '0px 8px 24px rgba(0, 0, 0, 0.6)' : '0px 4px 10px rgba(0, 0, 0, 0.1)', // Stronger shadow in dark mode
          backdropFilter: currentMode === 'dark' ? 'blur(15px) saturate(2)' : 'none', // Add blur and saturation in dark mode
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          background: currentMode === 'dark' ? '#12121200' : '#ffffff', // Dark transparent background for dark mode
          backdropFilter: currentMode === 'dark' ? 'blur(45px) saturate(2)' : 'none', // Apply blur and saturation in dark mode
          borderRadius: 8, // Rounded corners for the Menu
          boxShadow: currentMode === 'dark' ? '0px 8px 24px rgba(0, 0, 0, 0.6)' : '0px 2px 6px rgba(0, 0, 0, 0.1)', // Shadow
          transition: 'background 0.3s ease, backdrop-filter 0.3s ease', // Smooth transition for background and filter
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          background: currentMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'inherit', // Slight background tint for MenuItem in dark mode
          transition: 'background-color 0.3s ease', // Smooth transition for background color change
          '&:hover': {
            background: currentMode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : '#f1f1f1', // Lighter background on hover
          },
        },
      },
    }
    // Apply custom button styles
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       background: currentMode === 'dark' ? '#292929' : 'inherit', // Dark background in dark mode, light in light mode
    //       color: currentMode === 'dark' ? '#0093ff' : 'inherit', // Set text color to #0093ff in dark mode
    //       transition: 'color 0.3s ease', // Smooth transition for color change
    //       '&:hover': {
    //         color: currentMode === 'dark' ? '#007bb5' : 'inherit', // Slightly darker on hover
    //       },
    //     },
    //   },
    // },
  },
});
